import React, { useState, useEffect } from 'react';
import { Container, Button, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { FaEye, FaEdit, FaTrashAlt } from 'react-icons/fa';
import { simplePostCall } from '../../api/ApiServices';
import ApiConfig from '../../api/ApiConfig';
import '../../Styles/yellocalfcss/ViewInvoice.css';
import ScaleLoader from 'react-spinners/ScaleLoader';

const ViewInvoiceCustomer = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // URL student ID

  const [invoices, setInvoices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [filters, setFilters] = useState({
    student: '',
    academicYear: ''
  });

  const loadInvoices = async () => {
    setIsLoading(true);
    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id") || 1005),
      api_key: localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
      language: "en",
      user_id: Number(localStorage.getItem("user_id") || 14857),
      student_id: Number(id),
      payment_mode: ""
    };

    try {
      const response = await simplePostCall(
        ApiConfig.CustomerView,
        JSON.stringify(requestBody)
      );

      if (response?.result && response.invoice_list) {
        setInvoices(response.invoice_list);
      } else {
        setInvoices([]);
        setMessage(response?.message || "No records found");
      }
    } catch (error) {
      console.error("Error loading invoices:", error);
      setMessage("Failed to load data.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadInvoices();
  }, [id]);

  const handleClear = () => {
    setFilters({ student: '', academicYear: '' });
  };

  // Filter logic applied before mapping
  const filteredInvoices = invoices.filter(inv => {
    const matchesStudent = inv.student_name.toLowerCase().includes(filters.student.toLowerCase());
    const matchesYear = filters.academicYear === "" || inv.academic_year === filters.academicYear;
    return matchesStudent && matchesYear;
  });

  return (
    <div className="upcoming-invoices-primary-wrapper">
      <Container fluid className="upcoming-invoices-container-wrapper">
        <div className="upcoming-invoices-header-section">
          <h1 className="upcoming-invoices-title-label">Customer Fee Invoices</h1>
        </div>

        {/* Filter Section */}
        <div className="upcoming-invoices-filter-section mb-4">
          <div className="upcoming-invoices-filter-controls d-flex gap-3">
            <Form.Control 
                className="upcoming-invoices-select-student"
                placeholder="Search Student Name..."
                value={filters.student}
                onChange={(e) => setFilters({...filters, student: e.target.value})}
                style={{ width: '300px' }}
            />
            
            <Form.Select 
                className="upcoming-invoices-select-year"
                value={filters.academicYear}
                onChange={(e) => setFilters({...filters, academicYear: e.target.value})}
                style={{ width: '200px' }}
            >
              <option value="">All Academic Years</option>
              {/* Unique years from data */}
              {[...new Set(invoices.map(item => item.academic_year))].map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </Form.Select>
            <Button style={{backgroundColor: "var(--color-primary)", border: "none"}}  onClick={handleClear} className="text-white">Clear</Button>
          </div>
        </div>

        {/* Table Header */}
        <div className="upcoming-invoices-table-header-row">
          <div className="upcoming-invoices-grid-layout text-muted small fw-bold">
            <div className="upcoming-invoices-header-cell">#</div>
            <div className="upcoming-invoices-header-cell">Invoice ID</div>
            <div className="upcoming-invoices-header-cell">Student</div>
            <div className="upcoming-invoices-header-cell">Academic Year</div>
            <div className="upcoming-invoices-header-cell">Demand Date</div>
            <div className="upcoming-invoices-header-cell">Total</div>
            <div className="upcoming-invoices-header-cell">Paid</div>
            <div className="upcoming-invoices-header-cell">Balance</div>
            {/* <div className="upcoming-invoices-header-cell text-center">Actions</div> */}
          </div>
        </div>

        {isLoading ? (
          <div className="text-center my-3"><ScaleLoader color="#F4BB44" /></div>
        ) : (
          <div className="upcoming-invoices-data-rows-wrapper">
            {filteredInvoices.length > 0 ? filteredInvoices.map((item, index) => (
              <div key={item.invoice_id} className="upcoming-invoices-row-card">
                <div className="upcoming-invoices-grid-layout align-items-center">
                  <div className="upcoming-invoices-data-cell">{index + 1}</div>
                  <div className="upcoming-invoices-data-cell fw-bold">INV-{item.invoice_id}</div>
                  <div className="upcoming-invoices-data-cell">{item.student_name}</div>
                  <div className="upcoming-invoices-data-cell">{item.academic_year}</div>
                  <div className="upcoming-invoices-data-cell">{item.demand_date}</div>
                  <div className="upcoming-invoices-data-cell text-success fw-bold">{item.amount_total}</div>
                  <div className="upcoming-invoices-data-cell text-primary">{item.amount_paid}</div>
                  <div className="upcoming-invoices-data-cell text-danger">{item.balance}</div>
                  <div className="upcoming-invoices-data-cell upcoming-invoices-action-cell text-center d-flex gap-2 justify-content-center">
                    {/* <button className="btn btn-sm btn-light border" title="View" onClick={() => navigate(`/accountant/view-receipt/${item.invoice_id}`)}><FaEye className="text-primary"/></button>
                    <button className="btn btn-sm btn-light border" title="Edit"><FaEdit className="text-secondary"/></button>
                    <button className="btn btn-sm btn-light border" title="Delete"><FaTrashAlt className="text-danger"/></button> */}
                  </div>
                </div>
              </div>
            )) : (
              <div className="yc-empty-state">
                {message || "No invoices found for this student."}
              </div>
            )}
          </div>
        )}
      </Container>
    </div>
  );
};

export default ViewInvoiceCustomer;